import { makeStyles } from '@mui/styles';

const useReportStyles = makeStyles(theme => ({
  saveBtn: {
    marginRight: 10,
  },
  container: {
    marginBottom: '40px',
  },
  title: {
    fontSize: '22px !important',
  },
  button: {
    fontSize: '16px !important',
  },
  deleteBtn: {
    fontSize: '16px !important',
    backgroundColor: '#f50057',
    marginLeft: '10px',
    color: '#fff',
  },
}));
export default useReportStyles;
